// @core/api/endpoints/localization/set_translation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetTranslationRequest,
  TranslationResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Set translation
 * Creates or updates a translation for a key in a specific locale. Triggers cache invalidation.
 */
export async function SetTranslation(
  data: SetTranslationRequest,
  options?: RequestOptions
): Promise<TranslationResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/translations`;
  const requestOptions = options;
  return client.put<TranslationResponse>(requestPath, data, requestOptions);
}
